var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkUnchecked = function SvgCheckmarkUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.89 11.11v77.78H11.11V11.11h77.78m0-11.11H11.11C5 0 0 5 0 11.11v77.78C0 95 5 100 11.11 100h77.78C95 100 100 95 100 88.89V11.11C100 5 95 0 88.89 0zm0 0"
  })));
};
export default SvgCheckmarkUnchecked;